var Handlebars = require("/Users/Chan9ry/Development/JWP/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"activityhelper-panel\">\n  <div class=\"activityhelper-bg\"></div>\n  <a class=\"close-btn\" href=\"javascript:void(0);\">X</a>\n  <div class=\"activityhelper-title\">\n    "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.o : depth0)) != null ? stack1.title : stack1), depth0))
    + "\n  </div>\n  <div class=\"activityhelper-content\">\n    <div class=\"activityhelper-chart\" id=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.o : depth0)) != null ? stack1.id : stack1), depth0))
    + "\">\n    </div>\n  </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/webpack/templates/activityhelper-template.handlebars
// module id = 2
// module chunks = 0